 import apiService from '../utils/apiInterceptor';

const adminService = {
  getDashboardData: async () => {
    return await apiService.get('/admin/dashboard');
  },

  getOrderStats: async (startDate, endDate) => {
    return await apiService.get('/admin/orders/stats', {
      params: { start_date: startDate, end_date: endDate }
    });
  },

  getInventoryLog: async () => {
    return await apiService.get('/admin/inventory/logs');
  },

  updateInventory: async (productId, quantity) => {
    return await apiService.post('/admin/update-act-qty', {
      product_id: productId,
      actualqty: quantity
    });
  },

  getMissingItems: async () => {
    return await apiService.get('/admin/missing-item-report');
  },

  submitMissingItem: async (data) => {
    return await apiService.post('/admin/submit-missing-item', data);
  },

  
  
    // Properties
    getProperties: async (params = {}) => {
      return await apiService.get('/admin/properties', { params });
    },
  
    getPropertyById: async (id) => {
      return await apiService.get(`/admin/property/${id}`);
    },
  
    createProperty: async (propertyData) => {
      return await apiService.post('/admin/property', propertyData);
    },
  
    updateProperty: async (id, propertyData) => {
      return await apiService.put(`/admin/property/${id}`, propertyData);
    },
  
    updatePropertyStatus: async (id, status) => {
      return await apiService.post(`/admin/property/status/${id}`, { status });
    },
  
    deleteProperty: async (id) => {
      return await apiService.delete(`/admin/property/${id}`);
    },
  
    // Users/Clients
    getUsers: async () => {
      return await apiService.get('/admin/users');
    },
  
    getUserById: async (id) => {
      return await apiService.get(`/admin/user/${id}`);
    },
  
    updateUserStatus: async (id, status) => {
      return await apiService.post(`/admin/user/status/${id}`, { status });
    },
  
    // Orders
    getOrders: async (filters = {}) => {
      return await apiService.get('/admin/orders', { params: filters });
    },
  
    getOrderById: async (id) => {
      return await apiService.get(`/admin/order/${id}`);
    },
  
    updateOrderStatus: async (id, status) => {
      return await apiService.post(`/admin/order/status/${id}`, { status });
    },
  
    // Products
    getProducts: async () => {
      return await apiService.get('/admin/products');
    },
  
    // Product Categories
    getCategories: async () => {
      return await apiService.get('/admin/categories');
    },
  
    // Property Types
    getPropertyTypes: async () => {
      return await apiService.get('/admin/property-types');
    },
  
    // Reports
    getSalesReport: async (startDate, endDate,user_id=null) => {
      return await apiService.get('/admin/reports/sales', {
        params: { start_date: startDate, end_date: endDate, customer_id:user_id}
      });
    },

    getItemsReport: async (params = {}) => {
      return await apiService.get('/order-reporting/items', { params });
    },

    getHireDurationReport: async (params = {}) => {
      return await apiService.get('/order-reporting/hire-duration', { params });
    },
  
    getInventoryReport: async () => {
      return await apiService.get('/admin/reports/inventory');
    },
  
    // Missing Items
    getMissingItems: async () => {
      return await apiService.get('/admin/missing-items');
    }
};

export default adminService;

